import React from "react";
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel";
import { fireGtmEvent } from "../../utils/functions";
import styled from "styled-components";

const WidgetWrapper = styled.div`
  @media only screen and (max-width: 720px) {
    margin-left: -16px;
    margin-right: -16px;
  }
  margin-top: 2%;
`;

function ProductCategory({ categoryData }) {
  return (
    <WidgetWrapper>
      <Carousel
        accessible={false}
        allowLocaleFormat={false}
        cardConfig={{
          cardHeaderHeight: "180px",
          customGridTemplate: {
            desktop: "18",
            mobile: "6",
          },
          customImageMinSize: "100px",
          focusEffect: true,
          hoverEffect: true,
          imageHoverAnimation: true,
        }}
        customProperties={{
          "aria-label": "ally accessible.",
        }}
        data={categoryData.map((data) => {
          return {
            image: data.category_image,
            newTab: data.new_tab,
            title: data.category_title,
            url: data.category_url,
          };
        })}
        environment="DEVELOPMENT"
        heading={{
          cardCount: "4",
          headline: ``,
          layoutName: "lob_widget",
          showMoreURL: "",
          subHeadline: "",
          widgetID: "",
          widgetName: "Promotions Widget",
          widgetWidth: "3",
          gtmParameters: {
            event: "trackEventNoEcommerce",
            eventActionClick: "click",
            eventActionView: "view",
            eventCategory: "Promotion | Product Category",
            eventLabelCardClick:
              "Promotion | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}",
            eventLabelHeadlineClick: "Promotion | headline | {{headline}}",
            eventLabelView: "Promotion",
          },
        }}
        isHideFooter={false}
        isLoading={false}
        fireGtm={(obj) => {
          fireGtmEvent(obj);
        }}
        gtmConsumerName="Promotion | Product Category"
        showMoreTextTarget="self"
        templateType="productCategory"
        theme="AIRASIA_CLASSIC"
        widgetName="Carousel"
        lazyLoadImage={true}
        enableProgressiveImageLoading={true}
      />
    </WidgetWrapper>
  );
}

export default ProductCategory;
